import React, { useState, useEffect } from "react";
import { lang } from "../../lang"; // Adjust path as necessary if lang.js moved
import "./AddFlashCardForm.css"; // CSS for this component

function AddFlashCardForm({ topicId, topicCategories = [], onAddCard }) {
  const [frontContent, setFrontContent] = useState("");
  const [backContent, setBackContent] = useState("");
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  // Reset form when topicId changes (e.g., user selects a different topic)
  useEffect(() => {
    setFrontContent("");
    setBackContent("");
    setSelectedCategoryIds([]);
  }, [topicId]);

  const handleCategoryToggle = (categoryId) => {
    setSelectedCategoryIds((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!frontContent.trim() || !backContent.trim()) {
      alert("Front and back content cannot be empty.");
      return;
    }
    if (!topicId) {
      alert("Cannot add card: No topic selected.");
      return;
    }
    onAddCard({
      topicId, // topicId is already part of the cardData object passed to onAddCard
      frontContent,
      backContent,
      categoryIds: selectedCategoryIds,
      difficulty: null,
    });
    setFrontContent("");
    setBackContent("");
    setSelectedCategoryIds([]);
  };

  if (!topicId) {
    return null;
  }

  return (
    <div className="add-flashcard-form-container">
      <h4>{lang.flashCards.addCard || "Add New Card to Topic"}</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor={`cardFront-${topicId}`}>
            {lang.flashCards.frontLabel || "Front:"}
          </label>
          <textarea
            id={`cardFront-${topicId}`}
            value={frontContent}
            onChange={(e) => setFrontContent(e.target.value)}
            placeholder="Question or statement..."
            rows="3"
          />
        </div>
        <div className="form-group">
          <label htmlFor={`cardBack-${topicId}`}>
            {lang.flashCards.backLabel || "Back:"}
          </label>
          <textarea
            id={`cardBack-${topicId}`}
            value={backContent}
            onChange={(e) => setBackContent(e.target.value)}
            placeholder="Answer or details..."
            rows="3"
          />
        </div>

        {topicCategories && topicCategories.length > 0 && (
          <div className="form-group">
            <label>{lang.flashCards.categoriesLabel || "Categories:"}</label>
            <div className="categories-checkbox-group-form">
              {topicCategories.map((category) => (
                <label
                  key={category.id}
                  className="category-checkbox-item-form"
                >
                  <input
                    type="checkbox"
                    checked={selectedCategoryIds.includes(category.id)}
                    onChange={() => handleCategoryToggle(category.id)}
                  />
                  {category.name}
                </label>
              ))}
            </div>
          </div>
        )}
        <button type="submit" className="add-card-submit-button">
          Save Card
        </button>
      </form>
    </div>
  );
}

export default AddFlashCardForm;
